import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import UserLayout from '../components/UserLayout.jsx';
import UserLoginForm from '../components/UserLoginForm.jsx';
import apiUtils from '../../../global/utils/api';
import {redirectToPage} from "../../../global/utils/routerUtils";
import {sendLogin} from "../authStore";

const UserLogin = () => {
    const params = new URLSearchParams(window.location.search);
    const email = params.get('email') || '';
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const loggedInUser = useSelector(state => state.auth.loggedInUser);

    const [user, setUser] = useState({ username: email, password: '' });
    const { redirect } = apiUtils.objectFromQueryString(location.search);
    const [titleView, setTitleView] = useState('Sign In');
    const [errorView, setErrorView] = useState('');

    useEffect(() => {
        if (loggedInUser) {
            let path = redirect || (loggedInUser.admin ? "/admin" :
                loggedInUser.instructor ? "/instructor" :
                    "/learn");

            try {
                const url = new URL(path);
                path = url.pathname;
            } catch {}

            history.replace(path);
        }
    }, [loggedInUser, redirect, history]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const { payload } = await dispatch(sendLogin(user));

        if (!payload?.success) {
            if (['902', 902, 404, '404'].includes(payload?.error?.code)) {
                const redirectUrl = `/user/register-error?errorCode=${payload?.error?.code || ''}&email=${user?.username || ''}&errorMessage=${payload?.error?.message || ''}`;
                await redirectToPage(redirectUrl);
            } else {
                setErrorView(payload?.error?.message || 'Double-check your email and password, then try again.');
                setTitleView('Hmm, that didn’t work.');
            }
        }

        if (payload.data?.id && payload.data?.success) {
            const userFromServer = payload.data;
            localStorage.setItem('user', JSON.stringify(userFromServer));
            dispatch({ type: 'LOGIN_SUCCESS', payload: userFromServer });

            setTimeout(() => {
                let from = location.state?.from?.pathname || redirect || (
                    userFromServer.admin ? "/admin" :
                        userFromServer.instructor ? "/instructor" :
                            "/learn"
                );

                try {
                    const url = new URL(from);
                    from = url.pathname;
                } catch {}

                history.replace(from, location.state);
            }, 1000);
        }
    };

    const handleChangeUser = (e) => {
        if (errorView) {
            setErrorView('');
            setTitleView('Sign In');
        }
        setUser({ ...user, [e.target.name]: e.target.value });
    }

    return (
        <UserLayout title="Sign in" className={'h-full min-h-[100vh]'}>
            <UserLoginForm
                user={user}
                handleChange={e => handleChangeUser(e)}
                handleSubmit={handleSubmit}
                redirectPath={location.search}
                titleView={titleView}
                errorView={errorView}
            />
        </UserLayout>
    );
};

export default UserLogin;
